var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    stroke: "currentColor",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LV---Vika-Modal",
    transform: "translate(-605.000000, -301.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(420.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(39.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(147.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 2,
    width: 16,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L12,4",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,4",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 L16,7",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.3a1c9a75d665756354394c7d698b2a8e.svg";
export { ForwardRef as ReactComponent };